<div class="content" *appLet="buttons$() | async as buttons">
  <div class="progession-row" *appLet="readyToNavigateDebouncer$ | async as readyToNavigate">
    <div class="actions" *appLet="isTablet$ | async as isTablet">
      @if (buttons?.previous) {
        @if (buttons?.previous?.visible) {
          @if (buttons.previous.onClick) {
            <button
              [rebrand]="true"
              (click)="buttons.previous.onClick()"
              [stbButton]="'secondary'"
              class="button button-previous"
              data-trackid="link-pensionplanNavigation-back"
            >
              <ng-container [ngTemplateOutlet]="previous"></ng-container>
            </button>
          } @else {
            @if (buttons.previous.link) {
              <button
                [rebrand]="true"
                [routerLink]="readyToNavigate ? buttons.previous.link : null"
                queryParamsHandling="merge"
                [stbButton]="'secondary'"
                role="link"
                class="button button-previous"
                data-trackid="link-pensionplanNavigation-back"
              >
                <ng-container [ngTemplateOutlet]="previous"></ng-container>
              </button>
            }
          }
        } @else {
          <div class="button-placeholder"></div>
        }
      }

      <ng-template #previous>
        @if (isTablet) {
          <i>arrow_left</i>
        } @else {
          {{ buttons.previous.text | fms }}
        }
      </ng-template>

      @if (buttons?.next?.visible) {
        @if (buttons.next.onClick) {
          <button
            (click)="buttons.next.onClick()"
            [stbButton]="'primary'"
            [rebrand]="true"
            class="button button-next"
            data-trackid="link-pensionplanNavigation-next"
          >
            {{ buttons.next.text | fms }}
          </button>
        } @else {
          @if (buttons.next.link) {
            <button
              [rebrand]="true"
              [routerLink]="readyToNavigate ? buttons.next.link : null"
              queryParamsHandling="merge"
              [stbButton]="'primary'"
              role="link"
              class="button button-next"
              data-trackid="link-pensionplanNavigation-next"
            >
              {{ buttons.next.text | fms }}
            </button>
          }
        }
      }
    </div>
    <div class="embedded">
      <ng-content></ng-content>
    </div>
    @if (progress) {
      <stb-loading-indicator-linear
        [fluid]="true"
        [rebrand]="true"
        [progress]="progress"
        [type]="'progress'"
      ></stb-loading-indicator-linear>
    }
  </div>
</div>
